
fx.ns("shared.social", class AuthComponent extends fx.components.VBox
{  
    constructor(parameters)
    {
        super();

        this._social = parameters.social;
        this._icon = parameters.icon;
        this._iconWidth = parameters.width;
        this._iconHeight = parameters.height;
        this._service = parameters.service;
        this._text = parameters.text || fx.text("Si rien ne ne se passe après avoir cliqué sur le bouton ci-dessus, veuillez autoriser votre navigateur à afficher les popups.");
        this._logo = parameters.logo || null;
        this._numberClicks = 0;
        this.callback = this.callback.bind(this);
    }

    // ------------- RENDER -------------- //   
     
    create()
    {
        let authPanel = new fx.components.VBox();
        this.addChild(authPanel, {width: '100%', height: '100%'});

        let title= new fx.components.Text({text: this._social, className: "title"});

        if (this._logo)
        {
            let container = new fx.components.Box('container');
            let logoWrapper = new fx.components.HBox('logo-wrapper');
            let facebookLogo = new fx.components.Image(this._logo);
            logoWrapper.addChild(facebookLogo, {width:48, height:48});
            logoWrapper.addChild(title, {top: -5});
            container.addChild(logoWrapper, {left:'center', height:48})
            authPanel.addChild(container, {width: '100%', height:48});
        }
        else
        {
            authPanel.addChild(title, {width: '100%'});
        }

		//let text1 = new fx.components.Text({text: fx.text("Cliquez sur le bouton ci-dessous pour vous connectez et autoriser notre application à importer vos photos."), className: "auth-text"});
		//authPanel.addChild(text1, {width: '100%'});
    
        // the picker is already up : the customer's own click opened the window and it went from Google
        // sign-in straight to the gallery, so there is nothing left to press here
        this._pickerOpen = !!(this._service && this._service.pickerOpen);

		let text1 = new fx.components.Text({ className: "auth-text",
			text : this._pickerOpen ? fx.text("Choisissez vos photos dans la fenêtre Google. Elles arriveront ici.")
			                        : fx.text("Cliquez sur le bouton ci-dessous pour commencer à importer vos photos.") });
		authPanel.addChild(text1, {width: '100%'});

        if (this._pickerOpen)
            return;

        // A real link, not a button : fx maps click to Hammer's tap on mobile, which is emitted from a
        // timer, so the window.open a button would do sits outside the gesture and gets blocked. The app
        // keeps the button — there the picker is opened natively. Only reached when the browser refused
        // the window the click tried to open, so the picker still needs a gesture of its own.
        this._pickerUrl = (!fx.get("flutter") && this._service && this._service.pickerUrl) ? this._service.pickerUrl : "";

        if (this._pickerUrl)
            this.authButton = new fx.components.Text({ className : "Button auth-button filled picker-link",
                text : '<a class="shape" href="' + this._pickerUrl + '" target="_blank" rel="noopener">' + fx.text("Vos photos") + '</a>' });
        else
            this.authButton = new fx.components.Button({label : fx.text("Vos photos"), className: 'auth-button filled'});

        authPanel.addChild(this.authButton, {left:'center'});

		this.popupWarning = new fx.components.Text({text: this._text, className: "auth-text"});		
        this.popupWarning.visibleAtStart = false;
        authPanel.addChild(this.popupWarning, {width: '100%'});	
    }

    onReady()
    {
        super.onReady();

        if (this._pickerOpen)   // already watching the session, and there is no button to wire
            return;

        if (!this._pickerUrl)
        {
            this.on("click", this.onAuth, this.authButton);
            return;
        }

        // the session watch needs no gesture, so it can start as soon as the screen is up
        this._service.watchPicker();

        // A native listener, not this.on("click") : on mobile fx routes that through Hammer's tap, which
        // is emitted from a timer and would put window.open outside the gesture. Opening the window
        // ourselves keeps a handle on it, so it can be closed once the photos are picked ; if the browser
        // refuses it, the link is left to navigate on its own and only the closing is lost.
        let link = this.node ? this.node.querySelector("a") : null;

        if (link)
            link.addEventListener("click", e => {
                if (this._service.openPickerWindow())
                    e.preventDefault();
            });
    }

	// ------------- HANDLERS -------------- //

    onAuth()
	{
        this._service.openPicker();
        
        this._numberClicks++;

        if (this._numberClicks >= 2)
            this.popupWarning.show();
    }

    callback(data)
    {
        //this.loading(false);

        if (data && data.error)
            this.trigger("error");
    }

});